import './App.css';

import { MemoryRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import React from 'react';
import PagesContainer from './pages';
import { store, persistor } from './lib/redux';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <PagesContainer />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
